import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-role-add",
  "use": "icon-role-add-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-role-add\">\n    <path d=\"M10.0012 4.375V15.625M15.6262 10H4.37622\" stroke-width=\"1.00189\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol